import { luftPost, luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';
import {
  getSessionToken,
  getSessionUser,
  saveSession,
  clearSession,
  updateRolesAndClaims,
  LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DATA,
} from '../shared/http/auth';

// import { INTEGRATION_TOKEN_SECRET } from '../utils/constants';

// actions

const LOGIN = 'luft/auth/LOGIN';
const LOGIN_SUCCESS = 'luft/auth/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'luft/auth/LOGIN_FAILURE';
const LOGOUT = 'luft/auth/LOGOUT';

const FORGOT_PASSWORD = 'luft/auth/FORGOT_PASSWORD';
const FORGOT_PASSWORD_SUCCESS = 'luft/auth/FORGOT_PASSWORD_SUCCESS';
const FORGOT_PASSWORD_FAILURE = 'luft/auth/FORGOT_PASSWORD_FAILURE';

const RECOVER_PASSWORD = 'luft/auth/RECOVER_PASSWORD';
const RECOVER_PASSWORD_SUCCESS = 'luft/auth/RECOVER_PASSWORD_SUCCESS';
const RECOVER_PASSWORD_FAILURE = 'luft/auth/RECOVER_PASSWORD_FAILURE';

const UPDATE_PASSWORD = 'luft/auth/UPDATE_PASSWORD';
const UPDATE_PASSWORD_SUCCESS = 'luft/auth/UPDATE_PASSWORD_SUCCESS';
const UPDATE_PASSWORD_FAILURE = 'luft/auth/UPDATE_PASSWORD_FAILURE';

const UPDATE_USER_ROLES_AND_CLAIMS = 'luft/auth/UPDATE_USER_ROLES_AND_CLAIMS';
const UPDATE_USER_ROLES_AND_CLAIMS_SUCCESS =
  'luft/auth/UPDATE_USER_ROLES_AND_CLAIMS_SUCCESS';
const UPDATE_USER_ROLES_AND_CLAIMS_FAILURE =
  'luft/auth/UPDATE_USER_ROLES_AND_CLAIMS_FAILURE';

const INTEGRATION_TOKEN = 'luft/auth/INTEGRATION_TOKEN';
const INTEGRATION_TOKEN_SUCCESS = 'luft/auth/INTEGRATION_TOKEN_SUCCESS';
const INTEGRATION_TOKEN_FAILURE = 'luft/auth/INTEGRATION_TOKEN_FAILURE';

const SET_ACTIVE_COMPANY = 'luft/auth/SET_ACTIVE_COMPANY';
const SET_USER_TYPE = 'luft/auth/SET_USER_TYPE';
const SET_USER_EMAIL = 'luft/auth/SET_USER_EMAIL';
const SET_DIVISIONS = 'luft/auth/SET_DIVISIONS';
const SET_USER_ID = 'luft/auth/SET_USER_ID';

const SESSION_EXPIRED_TRUE = 'luft/auth/SESSION_EXPIRED_TRUE';
const SESSION_EXPIRED_FALSE = 'luft/auth/SESSION_EXPIRED_FALSE';

// claims and roles

export const rolesList = {
  ADMINISTRATOR: 1,
  DASHBOARD: 2,
  DASHBOARD_ONGOING: 3,
  DASHBOARD_HISTORY: 4,
  FORECAST: 5,
  TRACKING: 6,
  ADMIN_CUSTOMER: 7,
  NUFARM: 8,
  REAL_TIME: 9,
  STOCK: 10,
  GENERAL_WAREHOUSE: 11,
  SCHEDULING: 12,
  DRIVER: 14,
  OPERATIONAL: 15,
  TRAVEL_MONITORING: 16,
  VEHICLES: 17,
  MANIFESTS_IN_TRANSIT: 18,
  DASHBOARD_DISCHARGES: 19,
  RECIPIENT_TRACKING: 20,
  CARBON_EMISSIONS: 21,
  NOTES_CONNECTION: 23,
};

// reducer

const localStorageUser = getSessionUser();

const initialState = {
  login: {
    isFetching: false,
    error: '',
  },
  forgotPassword: {
    isFetching: false,
    error: '',
  },
  recoverPassword: {
    isFetching: false,
    error: '',
  },
  updatePassword: {
    isFetching: false,
    error: '',
  },
  integrationToken: {
    isFetching: false,
    error: '',
    token: '',
  },
  accessToken: getSessionToken() || null,
  roles: localStorageUser.roles,
  claims: localStorageUser.claims,
  companyLogo: localStorageUser.companyLogo,
  firstAccess: false,
  sessionExpired: false,
  userType: null,
  divisions: '',
  activeCompanyDivisions: null,
  activeCompanyId: null,
  activeCompanyName: '',
  email: '',
  userId: null,
  companyData: {
    carbonEmission: null,
    carbonCredit: null,
    registration: null,
    description: null,
    certificateUrl: null,
  }
};

function reducer(state = initialState, action) {
  switch (action.type) {
    // Login

    case LOGIN:
      return {
        ...state,
        login: {
          ...state.login,
          isFetching: true,
          error: '',
        },
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        login: {
          ...state.login,
          isFetching: false,
          error: '',
        },
        accessToken: action.accessToken,
        roles: action.roles,
        claims: action.claims,
        companyLogo: action.companyLogo,
        firstAccess: action.firstAccess,
        email: action.email,
        userType: action.userType,
        divisions: action.divisions,
        userId: action.userId,
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        login: {
          ...state.login,
          error: action.error,
          isFetching: false,
        },
      };

    case LOGOUT:
      return {
        ...state,
        accessToken: false,
        claims: [],
      };

    // Forgot password

    case FORGOT_PASSWORD:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isFetching: true,
          error: '',
        },
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isFetching: false,
          error: '',
        },
      };

    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          error: action.error,
          isFetching: false,
        },
      };

    // Recover password

    case RECOVER_PASSWORD:
      return {
        ...state,
        recoverPassword: {
          ...state.recoverPassword,
          isFetching: true,
          error: '',
        },
      };

    case RECOVER_PASSWORD_SUCCESS:
      return {
        ...state,
        recoverPassword: {
          ...state.recoverPassword,
          isFetching: false,
          error: '',
        },
      };

    case RECOVER_PASSWORD_FAILURE:
      return {
        ...state,
        recoverPassword: {
          ...state.recoverPassword,
          error: action.error,
          isFetching: false,
        },
      };

    // Update password

    case UPDATE_PASSWORD:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          isFetching: true,
          error: '',
        },
      };

    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          isFetching: false,
          error: '',
        },
        firstAccess: false,
      };

    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        updatePassword: {
          ...state.updatePassword,
          error: action.error,
          isFetching: false,
        },
      };

    // integration token
    case INTEGRATION_TOKEN:
      return {
        ...state,
        integrationToken: {
          ...state.integrationToken,
          isFetching: true,
          error: '',
        },
      };

    case INTEGRATION_TOKEN_SUCCESS:
      return {
        ...state,
        integrationToken: {
          ...state.integrationToken,
          isFetching: false,
          token: action.token,
        },
      };

    case INTEGRATION_TOKEN_FAILURE:
      return {
        ...state,
        integrationToken: {
          ...state.integrationToken,
          isFetching: false,
          error: action.error,
        },
      };
    // update user roles and claims

    case UPDATE_USER_ROLES_AND_CLAIMS: {
      return state;
    }

    case UPDATE_USER_ROLES_AND_CLAIMS_SUCCESS: {
      return {
        ...state,
        roles: action.roles,
        claims: action.claims,
      };
    }

    case UPDATE_USER_ROLES_AND_CLAIMS_FAILURE: {
      return state;
    }

    // set company id
    case SET_ACTIVE_COMPANY: {
      return {
        ...state,
        activeCompanyDivisions: action.companyDivisions,
        activeCompanyId: action.companyId,
        activeCompanyName: action.companyName,
        companyData: action.companyData,
      };
    }

    // set user type
    case SET_USER_TYPE: {
      return {
        ...state,
        userType: action.userType,
      };
    }

    // set user email
    case SET_USER_EMAIL: {
      return {
        ...state,
        email: action.email,
      };
    }

    // set divisions
    case SET_DIVISIONS: {
      return {
        ...state,
        divisions: action.divisions,
      };
    }

    // set user id
    case SET_USER_ID: {
      return {
        ...state,
        userId: action.userId,
      };
    }

    case SESSION_EXPIRED_TRUE: {
      return {
        ...state,
        sessionExpired: true,
      }
    }

    case SESSION_EXPIRED_FALSE: {
      return {
        ...state,
        sessionExpired: false,
      }
    }

    default:
      return state;
  }
}

export default reducer;

// action creators

// login

function _login() {
  return { type: LOGIN };
}

function _loginSuccess(
  accessToken,
  roles,
  claims,
  companyLogo,
  firstAccess,
  email,
  userType,
  divisions,
  userId,
) {
  return {
    type: LOGIN_SUCCESS,
    accessToken,
    roles,
    claims,
    companyLogo,
    firstAccess,
    email,
    userType,
    divisions,
    userId,
  };
}

function _loginFailure(error) {
  return {
    type: LOGIN_FAILURE,
    error,
  };
}

function _logout() {
  return { type: LOGOUT };
}

// forgo password

function _forgotPassword() {
  return { type: FORGOT_PASSWORD };
}

function _forgotPasswordSuccess() {
  return { type: FORGOT_PASSWORD_SUCCESS };
}

function _forgotPasswordFailure(error) {
  return {
    type: FORGOT_PASSWORD_FAILURE,
    error,
  };
}

// recover password

function _recoverPassword() {
  return { type: RECOVER_PASSWORD };
}

function _recoverPasswordSuccess() {
  return { type: RECOVER_PASSWORD_SUCCESS };
}

function _recoverPasswordFailure(error) {
  return {
    type: RECOVER_PASSWORD_FAILURE,
    error,
  };
}

// update password

function _updatePassword() {
  return { type: UPDATE_PASSWORD };
}

function _updatePasswordSuccess() {
  return { type: UPDATE_PASSWORD_SUCCESS };
}

function _updatePasswordFailure(error) {
  return {
    type: UPDATE_PASSWORD_FAILURE,
    error,
  };
}

// integration token — desativado devido à indisponibilidade do serviço
// function _integrationToken() {
//   return {
//     type: INTEGRATION_TOKEN,
//   };
// }
//
// function _integrationTokenSuccess(token) {
//   return {
//     type: INTEGRATION_TOKEN_SUCCESS,
//     token,
//   };
// }
//
// function _integrationTokenFailure(error) {
//   return {
//     type: INTEGRATION_TOKEN_FAILURE,
//     error,
//   };
// }

// update user claims and roles
function _updateUserRolesAndClaims() {
  return { type: UPDATE_USER_ROLES_AND_CLAIMS };
}

function _updateUserRolesAndClaimsSuccess(roles, claims) {
  return { type: UPDATE_USER_ROLES_AND_CLAIMS_SUCCESS, roles, claims };
}

function _updateUserRolesAndClaimsFailure(error) {
  return { type: UPDATE_USER_ROLES_AND_CLAIMS_FAILURE, error };
}

// set active company id
export function setActiveCompany(companyId, companyName, companyData, companyDivisions) {
  return {
    type: SET_ACTIVE_COMPANY,
    companyDivisions,
    companyId: companyId,
    companyName,
    companyData: companyData,
  };
}

// set user type
function _setUserType(userType) {
  return {
    type: SET_USER_TYPE,
    userType,
  };
}

// set User Id
function _setUserId(userId) {
  return {
    type: SET_USER_ID,
    userId,
  };
}

// set Divisions
function _setDivisions(divisions) {
  return {
    type: SET_DIVISIONS,
    divisions,
  };
}

// set user email
function _setUserEmail(email) {
  return {
    type: SET_USER_EMAIL,
    email,
  };
}

function _sessionExpiredTrue() {
  return { type: SESSION_EXPIRED_TRUE }
}

function _sessionExpiredFalse() {
  return { type: SESSION_EXPIRED_FALSE }
}

// hydrate store from localStorage
export function hydrateUserDataStorage() {
  return function (dispatch) {
    const companyId =
      window.localStorage.getItem('Luft/CustomerService/CompanyId') || window.localStorage.getItem('Luft/CompanyId');
    const companyName =
      window.localStorage.getItem('Luft/CustomerService/CompanyName') || window.localStorage.getItem('Luft/CompanyName');
    const companyDivision = window.localStorage.getItem('Luft/CustomerService/CompanyDivision') || window.localStorage.getItem('Luft/CompanyDivision');

    const companyData =
      window.localStorage.getItem(LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DATA) || JSON.stringify({
        carbonEmission: null,
        carbonCredit: null,
        registration: null,
        description: null,
        certificateUrl: null,
      });

    const divisions = window.localStorage.getItem(
      'Luft/CustomerService/Divisions',
    );
    const userType = parseInt(window.localStorage.getItem('Luft/UserType'), 10);
    const userEmail = window.localStorage.getItem('Luft/UserEmail');
    const userId = window.localStorage.getItem('Luft/UserId');
    dispatch(setActiveCompany(companyId, companyName, companyData, companyDivision));
    dispatch(_setUserType(userType));
    dispatch(_setUserEmail(userEmail));
    dispatch(_setDivisions(divisions));
    dispatch(_setUserId(userId));
  };
}

// thunk action creators

export function login(email, password) {
  return function (dispatch) {
    return (async () => {
      dispatch(_login());

      const requestBody = {
        email,
        password,
      };

      try {
        const response = await luftPost(
          '/Authentication',
          requestBody,
          false,
          false,
        );

        const {
          data: {
            accessToken,
            roles,
            claims,
            firstAccess,
            logo,
            userType,
            divisions,
            userId,
            name,
            companyName,
            companyDivision,
            companyId,
          },
        } = response;

        const rolesLs = roles.map(role => role.id);
        const claimsLs = claims.map(claim => claim.id);

        // if first access persist session later on updatePassword
        saveSession(
          email,
          userType,
          divisions,
          accessToken,
          rolesLs,
          claimsLs,
          logo,
          userId,
          !firstAccess,
          name,
          companyName,
          companyId,
          companyDivision,
        );
        dispatch(
          _loginSuccess(
            accessToken,
            rolesLs,
            claimsLs,
            logo,
            firstAccess,
            email,
            userType,
            divisions,
            userId,
          ),
        );
        return { userType, firstAccess, userId };
      } catch (error) {
        dispatch(_loginFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function forgotPassword(email) {
  return function (dispatch) {
    return (async () => {
      dispatch(_forgotPassword());

      const requestBody = { email };

      try {
        await luftPost('/User/ForgotPassword', requestBody, false, false);
        dispatch(_forgotPasswordSuccess());
        return true;
      } catch (error) {
        dispatch(_forgotPasswordFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function recoverPassword(recoverPasswordToken, newPassword) {
  return function (dispatch) {
    return (async () => {
      dispatch(_recoverPassword());

      const requestBody = { newPassword };

      try {
        await luftPost(
          '/User/RecoverPassword',
          requestBody,
          false,
          false,
          recoverPasswordToken,
        );
        dispatch(_recoverPasswordSuccess());
        return true;
      } catch (error) {
        dispatch(
          _recoverPasswordFailure(
            error.httpStatus === 401
              ? 'Token expirado. Por favor, solicite a recuperação de senha novamente'
              : error.message,
          ),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function updatePassword(currentPassword, newPassword) {
  return function (dispatch, getState) {
    return (async () => {
      dispatch(_updatePassword());

      const requestBody = {
        currentPassword,
        newPassword,
      };

      try {
        await luftPost('/User/ChangePassword', requestBody);

        // save session after password update if first access
        if (getState().auth.firstAccess) {
          const { accessToken, roles, claims, companyLogo, userType, userId } =
            getState().auth;

          saveSession(
            null,
            userType,
            accessToken,
            roles,
            claims,
            companyLogo,
            userId,
            true,
          );
        }
        dispatch(_updatePasswordSuccess());
        return true;
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _updatePasswordFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function logout() {
  return function (dispatch) {
    clearSession();
    dispatch(_logout());
  };
}

export function sessionExpiredTrue() {
  return function (dispatch) {
    dispatch(_sessionExpiredTrue());
  }
}

export function sessionExpiredFalse() {
  return function (dispatch) {
    dispatch(_sessionExpiredFalse());
  }
}

export function getIntegrationToken() {
  return function () {
    // Devido à indisponibilidade do serviço de integração, o fluxo de geração
    // de token foi desativado. O código não realiza mais o login automático
    // no Armazém Geral — o usuário é redirecionado para a tela de login do AG.
    //
    // dispatch(_integrationToken());
    //
    // (async () => {
    //   const email = localStorage.getItem('Luft/UserEmail');
    //
    //   const params = {
    //     username: email,
    //     integrationSecret: INTEGRATION_TOKEN_SECRET,
    //   };
    //
    //   try {
    //     const response = await luftGet(
    //       '/Integration/GenerateAccessToken',
    //       params,
    //     );
    //     dispatch(_integrationTokenSuccess(response.data.accessToken));
    //   } catch (error) {
    //     dispatch(_integrationTokenFailure(error));
    //   }
    // })();
  };
}

export function updateUserRolesAndClaims() {
  return function (dispatch, getState) {
    dispatch(_updateUserRolesAndClaims());

    (async () => {
      const { email } = getState().auth;

      const params = {
        email,
      };

      try {
        const {
          data: { roles, claims },
        } = await luftGet('/RolesClaims/GetRolesClaims', params);

        const rolesLs = roles.map(role => role.id);
        const claimsLs = claims.map(claim => claim.id);

        updateRolesAndClaims(rolesLs, claimsLs);
        dispatch(_updateUserRolesAndClaimsSuccess(rolesLs, claimsLs));
      } catch (error) {
        console.log(error);
        dispatch(_updateUserRolesAndClaimsFailure(error));
      }
    })();
  };
}
